import { DateFilterState, DEFAULT_DATE_FILTER_VALUE } from './date.types';

export const getDefaultDateFilter = (): DateFilterState => ({
  selectedDate: DEFAULT_DATE_FILTER_VALUE,
});
export const defaultArtistsFilter = getDefaultDateFilter();
